import {
  SubAccountCreateInterface,
  SubAccountErrorsInterface,
} from '../types/sub-account-interface'

export const subAccountDefaultErrors: SubAccountErrorsInterface = {
  name: '',
  domain: '',
}

export const subAccountDefaultCreateValues: SubAccountCreateInterface = {
  name: '',
  domain: '',
}
